














































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
@Component({
  $_veeValidate: { validator: 'new' },
})
export default class Mascotas extends Vue {
  private valid = true;
  /* Alterts */
  private vacuna = 'd-none';
  private cachorro = 'd-none';
  private adulto = 'd-none';
  private braqui = 'd-none';

  private name = '';
  private select = null;
  private mascotasVacuna: any = [];
  private mascotasCachorro: any = [];
  private mascotasBraqui: any = [];
  private mascotasAdulto: any = [];

  private mascotasCliente:any = []; // Array para llenar el select
  private mascotasAElegir:any = [];
  private mascotasParaEditar: any = [];
  private checkbox = false;
  private errores = false;
  private dialogMascotas = false;
  private alert = 'd-none';
  private camposVisibles = '';
  /* SnackBar */
  private snackbar = false;
  private text = '';
  private type = '';
  private timeout = 2000;
  private idPetco = this.$store.getters.user;
  private terms = false;
  private terminos: any = '';
  private termsDialog = false;
  /* Dialog Editar mascota*/
  private dialogEdit = false;
  private mascotaEditar = [];
  private paso = 2;
  private timeOutInicial: any = this.$store.getters.timeOut;
  private timeOut: any = 0;
  private intervalo: any;
  private dialogTime = false;

  private dialogConfirm = false;

  // Ir atrás 
  private async goBack() {
    history.back();
  }

  private unlock() {
    if (this.$store.getters.user !== null && this.$store.getters.user !== undefined && this.$store.getters.user !== '') {
      const idCitas: any = [];
      let data = { idCliente: this.$store.getters.user, idCita: [] };
      for (const id of this.$store.getters.idCitaBloqueo) {
        idCitas.push(id.ID_CITA);
      }
      if (idCitas.length > 0) { // Hay citas
        data.idCita = idCitas;
        const promise = this.$store.dispatch('desbloquearHorarioCita', data);
        promise.then(async (val) => {
          if (val === 200) {
            return true;
          }
        });
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  // Ir a Home
  private async home() {
    this.unlock();
    if (await this.$store.dispatch('isDefined', this.$store.getters.idCallCenter)) {
      this.$store.dispatch('resetAll');
      this.$store.commit('setUser', undefined);
      this.$router.push('/callCenter/clubpetco');
    } else {
      this.$store.dispatch('resetAll');
      this.$router.push('/tiendas');
    }
  }

  private resetTimeOut() {
    this.timeOutInicial = 0;
    this.timeOut = 0;
    this.intervalo = 0;
  }

  // Llamada al momento de la carga de la página
  private created() {
    this.dialogMascotas = true;
    const promise = this.$store.dispatch('getMascotasCliente', this.idPetco);
    promise.then((value) => {
      this.valid = true;
      this.errores = false;
      if (Object.keys(value).length === 0) { // El cliente no tiene mascotas
        this.alert = '';
        this.camposVisibles = 'd-none';
        this.valid = false;
      } else {
        this.mascotasParaEditar = value;
        // Filtramos mascotas no fallecidas
        for (let i of value) {
          if (i.FALLECIDO !== 'X' && (i.TIPO === 'P' || i.TIPO === 'G')) {
            this.mascotasCliente.push(i);
          }
        }
        if (this.$store.getters.mascotasCita.length > 0) {
          this.mascotasAElegir = this.$store.getters.mascotasCita;
          this.limitar(this.mascotasAElegir);
        }
      }
      this.dialogMascotas = false;
    })
    .catch((error) => {
      this.errores = true;
      this.valid = false;
      setTimeout( () => { this.dialogMascotas = false; }, 6000); // Si tarda más de 6 seg sin responder
    });


    // Llamamos a la cuenta regresiva
    if (this.timeOutInicial > 0) { // Edición
      this.timeOutInicial = Date.now() + this.timeOutInicial -3000;
      this.intervalo = setInterval( () => {
        this.timeOut =  this.cuentaRegresiva(this.timeOutInicial);
        if (this.timeOut <= 1) { // se acabó el tiempo, se resetea todo
          clearInterval(this.intervalo);
          this.resetTimeOut();
          this.dialogTime = true;
        }
      }, 1000);
    }
  }

  // Redirige a tiendas una vez que se acabó el tiempo
  private async goTiendas(){
    this.$store.dispatch('resetAll');
    this.$router.push(await this.$store.dispatch('isDefined', this.$store.getters.idCallCenter) ? '/callCenter/tiendas' : '/tiendas');

  }

  // Cuenta regresiva
  private cuentaRegresiva(deadline: any) {
    let now: any = new Date();
    let t: any = new Date(deadline);
    let tiempoRestante = (t - now + 1000) / 1000;
    let segRestantes = ('0' + Math.floor(tiempoRestante % 60)).slice(-2);
    let minRestantes = ('0' + Math.floor(tiempoRestante / 60 % 60)).slice(-2);
    return tiempoRestante * 1000;
  }

  @Watch('mascotasCliente')
  private onMascotasLoaded(masc: any) {
    if (masc.length === 0) {
      this.dialogMascotas = true;
    } else {
      this.dialogMascotas = false;
    }
  }
  //Editar Mascota
  private async editaMascota() {
    if (Object.keys(this.mascotaEditar).length > 0) {
      this.$store.dispatch('saveMascotaEditar', this.mascotaEditar);
      this.$router.push(await this.$store.dispatch('isDefined', this.$store.getters.idCallCenter) ? '/callCenter/editarMascota' : '/editarMascota');
    }
  }

  @Watch('terminos')
  private accept(accepts: any) {
    if (accepts === true) {
      this.valid = true;
    }
  }

  private expirada(value: any, index: any, self: any) {
    return value.STAT_EXP_VACUNA === '3';
  }

  private async add() {
    this.$router.push(await this.$store.dispatch('isDefined', this.$store.getters.idCallCenter) ? '/callCenter/agrMascota' : '/agrMascota');
  }

  private checkTipoMascota(array: any) {
    if (array.length > 0) {
      for (const i of array) {
        if (i.TIPO !== array[0].TIPO) {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  }

  // Razas de Braquicéfalos a excluir
  private excepcionBraquicelafo(raza: any) {
    let razas = ['00041', '00121', '00097', '00156', '00100'];
    return razas.indexOf(raza) >= 0 ? true: false;
  }

  private checkBraquicefalo(array: any) {
    let retorno = false;
    if (array.length > 0) {
      for (const i of array) {
        if (i.BRAQUICEFALO === 'X' && !this.excepcionBraquicelafo(i.RAZA)) {
          this.mascotasBraqui.push(i);
          retorno = true;
        }
      }
    }
    return retorno;
  }

  private checkAdultoMayor(array: any) {
    let retorno = false;
    if (array.length > 0) {
      for (const i of array) {
        if (parseInt(i.MESES) >= 120) {
          this.mascotasAdulto.push(i);
          retorno = true;
        }
      }
    }
    return retorno;
  }

  private checkCachorro(array: any) {
    let retorno = false;
    if (array.length > 0) {
      for (const i of array) {
        if (parseInt(i.MESES) <= 6) {
          this.mascotasCachorro.push(i);
          retorno = true;
        }
      }
    }
    return retorno;
  }

  private writeMascotas(array: any) {
    if(array.length > 0) {
      let stringMascotas = '';
      for (const mascota of array) {
        stringMascotas += mascota.NOMBRE + ', ';
      }
      stringMascotas = stringMascotas.substring(0, stringMascotas.length - 2);
      return stringMascotas;
    }
  }

  private writeFechas(array: any) {
    if(array.length > 0) {
      let stringFechas = '';
      for (const mascota of array) {
        stringFechas += this.formatDate(mascota.EXP_VACUNA) + ', ';
      }
      stringFechas += ' ';
      return stringFechas;
    }
  }
  //Revisa las vacunas de la mascota seleccionada
  private checkVacuna(array: any) {
    const resp = [];
    if (array.length > 0) {
      for (const i of array) {
        if (i.STAT_EXP_VACUNA === '' ||
        i.STAT_EXP_VACUNA === '1') {
           resp.push([1, '']);
        } else if (i.STAT_EXP_VACUNA === '2') {
          const fecha = i.EXP_VACUNA;
          const anio = fecha.substring(0, 4);
          const mes = fecha.substring(4, 6);
          const dia = fecha.substring(6, 8);
          const fechaCompleta = anio + '-' + mes + '-' + dia;
          const fechaExp = new Date(fechaCompleta).getTime();
          const hoy = new Date().toISOString().slice(0,10);
          const today = new Date(hoy).getTime();
          const diff = fechaExp - today;
          const dias = diff / (1000*60*60*24);
           resp.push([2,
             'El ' + this.formatDate(i.EXP_VACUNA) + ' expira la vacuna de ' + i.NOMBRE + ', restan ' + dias +
             ' días' ]);
        } else if (i.STAT_EXP_VACUNA === '3') {
        this.vacuna = '';
        resp.push([3,
          'La vacuna de ' + i.NOMBRE + ' expiró el '+ this.formatDate(i.EXP_VACUNA) +', es necesario que presentes su cartilla de '+
          'vacunación vigente el día de la cita, de lo contrario no se te otorgará el servicio']);
        }
      }
      return resp;
    }
  }

  private limitar(e: any) {
    this.mascotasAdulto = [];
    this.mascotasCachorro = [];
    this.mascotasBraqui = [];
    this.cachorro = 'd-none';
    this.adulto = 'd-none';
    this.braqui = 'd-none';
    // Cantidad de mascotas
    if (e.length > 4) {
        this.snackbar = true;
        this.type = 'error';
        this.timeout = 3000;
        this.text = 'Solo puedes seleccionar 4 mascotas a la vez.';
        e.pop();
    } else if (e.length === 0) {
      this.vacuna = 'd-none';
      this.mascotasVacuna = [];
    }
    
    // No escogió tipos de mascota iguales
    if (!this.checkTipoMascota(e)) { 
      if (e.length > 0) {
        this.snackbar = true;
        this.timeout = 3000;
        this.type = 'error';
        this.text = 'Solo puedes seleccionar mascotas del mismo tipo.';
        e.pop();
      }
    } else if (this.checkTipoMascota(e)) {
      this.mascotasVacuna = e.filter(this.expirada);
      if (this.mascotasVacuna.length === 0) {
        this.vacuna = 'd-none';
      } else {
        this.vacuna = '';
      }
      if (e.length > 0) {
        this.valid = true;
        const resp: any = this.checkVacuna(e);
        let re: any;
        for (re of resp) {
          if (re[0] === 3) {
            this.snackbar = false;
            this.text = re[1];
            this.mascotasVacuna = e.filter(this.expirada);
            this.terminos = '';
          } else if (re[0] === 2) {
            this.snackbar = true;
            this.timeout = 5000;
            this.type = 'warning';
            this.text = re[1];
            this.terminos = true;
          } else {
            this.terminos = true;
          }
        }
      }
    }
    // Tipo de mascota
    if (this.checkBraquicefalo(e)) { // Braquicefalo
      this.braqui = '';
    }
    if (this.checkAdultoMayor(e)) { // Mascota adulto mayor
      this.adulto = '';
    }
    if (this.checkCachorro(e)) { // Mascota cachorro
      this.cachorro = '';
    }
  }

  /**** Validación del formulario *****/
  private validateForm() {
    this.$validator.validate()
    .then(async (result) => {
        if (result) {
          let bandera = this.$store.getters.bandera;
          if (bandera !== 9) { // Flujo normal
            this.$store.dispatch('selectMascotas', this.mascotasAElegir);
            this.$store.dispatch('updateBandera', 3);
            this.$router.push(await this.$store.dispatch('isDefined', this.$store.getters.idCallCenter) ? '/callCenter/servicios' : '/servicios');
          } else { // Cambio de mascotas
            clearInterval(this.intervalo);
            // Buscar si hubo cambios convirtiendo los arreglos a texto y comparándolos
            if (JSON.stringify(this.mascotasAElegir) === JSON.stringify(this.$store.getters.mascotasCita)) {
              clearInterval(this.intervalo);
              this.$store.commit('setTimeOut', this.timeOut);
              this.resetTimeOut();
              clearInterval(this.intervalo);
              this.valid = false;
              this.$router.push(await this.$store.dispatch('isDefined', this.$store.getters.idCallCenter) ? '/callCenter/resumenCita' : '/resumenCita'); // Ruta a seguir si son iguales
            }
            else {
              clearInterval(this.intervalo);
              this.$store.commit('setTimeOut', 0);
              this.resetTimeOut();
              this.$store.dispatch('selectMascotas', this.mascotasAElegir); // Actualizar mascotas
              this.valid = false;
              this.$router.push(await this.$store.dispatch('isDefined', this.$store.getters.idCallCenter) ? '/callCenter/servicios' : '/servicios'); // Ruta a seguir luego de actualizar
            }
          }

        } else {
          this.snackbar = true;
          if (this.mascotasAElegir.length === 0) {
            this.type = 'error';
            this.text = 'Selecciona al menos una mascota.';
          }
          else {
            this.type = 'error';
            this.text = 'Confirma que has leído los requerimientos de vacunación.';
          }
          this.valid = false;
        }
    });
  }
  private formatDate(fecha: any) {
    const anio = fecha.substring(0, 4);
    const mes = fecha.substring(4, 6);
    const dia = fecha.substring(6, 8);
    let mesString = '';
    if (mes === '01') {
      mesString = 'Enero';
    } else if (mes === '02') {
      mesString = 'Febrero';
    } else if (mes === '03') {
      mesString = 'Marzo';
    } else if (mes === '04') {
      mesString = 'Abril';
    } else if (mes === '05') {
      mesString = 'Mayo';
    } else if (mes === '06') {
      mesString = 'Junio';
    } else if (mes === '07') {
      mesString = 'Julio';
    } else if (mes === '08') {
      mesString = 'Agosto';
    } else if (mes === '09') {
      mesString = 'Septiembre';
    } else if (mes === '10') {
      mesString = 'Octubre';
    } else if (mes === '11') {
      mesString = 'Noviembre';
    } else if (mes === '12') {
      mesString = 'Diciembre';
     } else {
       return 'no se tiene registrada';
     }
    return 'expiró el ' + dia + ' de ' + mesString + ' de ' + anio;
  }
}
